import React, { useState } from 'react'
import { TextFields } from '../../../../../components'
import { Avatar, Typography } from '@mui/material'

const ProfileForm = () => {
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)

  console.log('----attributes',attributes);
  

  const [name, setName] = useState(attributes?.employee_name)
  const [phoneNo, setPhonNo] = useState(attributes?.employee_contact_number)
  const [email, setEmail] = useState(attributes?.employee_email)
  const [school_name, setSchoolName] = useState(attributes?.school_name)
  return (
    <div style={{ display: 'flex', gap: '50px', marginTop: '30px', alignItems: 'flex-start' }}>
      <div>
        <ProfileField title={'School Name'}>
          <TextFields
            value={school_name}
            onChange={(e) => setSchoolName(e.target.value)}
            placeholder={'Enter Name'}
            width={'313px'}
            readOnly
          />
        </ProfileField>
        <ProfileField title={'Name'}>
          <TextFields
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={'Enter Name'}
            width={'313px'}
            readOnly
          />
        </ProfileField>

        <ProfileField title={'Contact Number'}>
          <TextFields
            placeholder={'1234567890'}
            width={'313px'}
            value={phoneNo}
            onChange={(e) => setPhonNo(e.target.value)}
            readOnly
          />
        </ProfileField>
        <ProfileField title={'Email'}>
          <TextFields
            placeholder={'1234567890'}
            width={'313px'}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            readOnly
          />
        </ProfileField>
      </div>
      <div className="add-profile-image-p">
        <Avatar
          sx={{
            bgcolor: '#F2ECF9',
            width: '70px',
            height: '70px',
            color: '#492972',
            fontSize: '26px',
            overflow: "hidden",
          }}
          variant="rounded"
          src={attributes?.employee_avatar || attributes?.employee_name}
        ></Avatar>
      </div>
    </div>
  )
}

export default ProfileForm

const ProfileField = ({ children, title, select }) => {
  return (
    <div className="profile-field-wrapper">
      <Typography className="profile-field-label" sx={{ width: select ? '220px' : '150px' }}>
        {title}
      </Typography>
      {children}
    </div>
  )
}
